import React, { useEffect, useState } from 'react';
import { StaticQuery, graphql } from "gatsby"
import { DocsBar, DocsBody, DocsHeader, DocsItem, DocsList } from './DocsSidebar.style';
import ArticleIcon from '@mui/icons-material/Article';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import TopicIcon from '@mui/icons-material/Topic';

export default function DocsSidebar() {
  const [openItems, setOpenItems] = useState({});

  const {pathname} = useLocation();

  const isActive = (slug) => {
        return slug === pathname;
  };

  useEffect(() => {
    setOpenItems({...openItems, [pathname] : true})
  },[]);

  const onSideBarItemClick = async (h, frontmatter) => {
    if(h.depth === 2){
      const key = frontmatter.slug;

      if(openItems.hasOwnProperty(key)){
        const openItemsCopy = {...openItems};
        delete openItemsCopy[key];

        setOpenItems(openItemsCopy);
      }
      else{
        setOpenItems({...openItems, [frontmatter.slug] : true});
      }
    }
    else if(h.depth === 3){
      await navigate(`${frontmatter.slug}#${h.value.toLowerCase()}`);
    }
  };

  const renderSideBarItems = (h, frontmatter) => {
    switch(h.depth){
      case 2:
        return(
          <DocsItem onClick={() => onSideBarItemClick(h, frontmatter)} isSub={false} isActive={isActive(frontmatter.slug, h.value, h.depth)}>
            <ArticleIcon fontSize={'small'}/>
            {h.value}
          </DocsItem>
        );
      case 3:
        if(openItems[frontmatter.slug]){
          return(
            <DocsItem onClick={() => onSideBarItemClick(h, frontmatter)} isSub={true} isActive={isActive(frontmatter.slug, h.value, h.depth)}>
              <TopicIcon fontSize={'small'}/>
              {h.value}
            </DocsItem>
          );
        }
        return null;
      default:
        return null;
    }
  };


  return (
    <StaticQuery
      query={graphql`
        query MyQuery {
          allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(docs)/"}}) {
              nodes {
                id
                headings {
                  value,
                  depth
                }
                frontmatter {
                  slug,
                  order
                }
              }
              
            }
        }
      `}

      render={({allMarkdownRemark}) => (
        <DocsBar>
          <DocsHeader>
            <h2>API Documentation</h2>
          </DocsHeader>
          <DocsBody>
            <DocsList>
              {allMarkdownRemark.nodes.sort((a,b) => +a.frontmatter.order > +b.frontmatter.order).map(({headings, frontmatter}) =>
                <>
                  {headings.map(h =>
                  h.depth <=3 ? renderSideBarItems(h, frontmatter) : null)}
                </>
                )}
            </DocsList>
          </DocsBody>
        </DocsBar>
      )}
    />
  )
}